"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = require("babel-runtime/helpers/toConsumableArray");

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _defineProperty2 = require("babel-runtime/helpers/defineProperty");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends3 = require("babel-runtime/helpers/extends");

var _extends4 = _interopRequireDefault(_extends3);

exports.default = user;
exports.isLoaded = isLoaded;
exports.load = load;
exports.markFreeSeen = markFreeSeen;
exports.activateTrial = activateTrial;
exports.setWorkInfo = setWorkInfo;
exports.redeemCode = redeemCode;
exports.validateVoucherCode = validateVoucherCode;
exports.redeemCodeAction = redeemCodeAction;
exports.acceptEpicWalletTerms = acceptEpicWalletTerms;
exports.fetchPointsRefundEligibility = fetchPointsRefundEligibility;
exports.creditToEpicWallet = creditToEpicWallet;
exports.getUserInfoForCashRefund = getUserInfoForCashRefund;
exports.registerUserForCashRefund = registerUserForCashRefund;
exports.retryForCashRefund = retryForCashRefund;
exports.getStatusForCashRefund = getStatusForCashRefund;

var _reactRouter = require("react-router");

var _assetDownloads = require("./assetDownloads");

var _subscriptions = require("./subscriptions");

var _topups = require("./topups");

var _auth = require("./auth");

var _academicUsers = require("./academicUsers");

var _payments = require("./payments");

var _bluebird = require("bluebird");

var _bluebird2 = _interopRequireDefault(_bluebird);

var _ramda = require("ramda");

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LOAD = "ms/user/load";
var LOAD_SUCCESS = "ms/user/load_success";
var _LOAD_SUCCESS = "ms/user/_load_success";
var LOAD_FAIL = "ms/user/load_fail";

var VOUCHER_LOAD = "ms/user/voucher_load";
var VOUCHER_SUCCESS = "ms/user/voucher_success";
var VOUCHER_FAIL = "ms/user/voucher_fail";

var ACTIVATE_TRIAL = "ms/subscriptions/activate";
var ACTIVATE_TRIAL_SUCCCESS = "ms/subscriptions/activate_success";
var ACTIVATE_TRIAL_FAIL = "ms/subscriptions/activate_fail";

var MARK_FREE_SEEN = "ms/subscriptions/mark_free_seen";
var MARK_FREE_SEEN_SUCCCESS = "ms/subscriptions/mark_free_seen_succcess";
var MARK_FREE_SEEN_FAIL = "ms/subscriptions/mark_free_seen_fail";

var REDEEM_COUPON = "ms/subscriptions/redeem_coupon";
var REDEEM_COUPON_SUCCESS = "ms/subscriptions/redeem_coupon_success";
var REDEEM_COUPON_FAIL = "ms/subscriptions/redeem_coupon_fail";

var GENERIC_ACTION = "GENERIC_ACTION";
var GENERIC_ACTION_SUCCESS = "GENERIC_ACTION_SUCCESS";
var GENERIC_ACTION_FAILED = "GENERIC_ACTION_FAILED";

var FETCH_REFUND_ELIGIBILITY = "FETCH_REFUND_ELIGIBILITY";
var FETCH_REFUND_ELIGIBILITY_SUCCESS = "FETCH_REFUND_ELIGIBILITY_SUCCESS";
var FETCH_REFUND_ELIGIBILITY_FAILED = "FETCH_REFUND_ELIGIBILITY_FAILED";

var FETCH_CASH_REFUND_STATUS = "FETCH_CASH_REFUND_STATUS";
var FETCH_CASH_REFUND_STATUS_SUCCESS = "FETCH_CASH_REFUND_STATUS_SUCCESS";
var FETCH_CASH_REFUND_STATUS_FAILED = "FETCH_CASH_REFUND_STATUS_FAILED";

var initialState = {
  loading: false,
  loaded: false,
  loadError: false,

  activatingTrial: false,
  trialError: "",
  activatedTrial: false,

  refundEligibility: {
    isLoading: true,
    data: null,
    error: null
  },
  cashRefundStatus: {
    isLoading: false,
    data: {},
    error: null
  }
};

// Reducer

function user() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case _auth.UPDATE_PASSWORD_SUCCESS:
      return (0, _extends4.default)({}, state, {
        etag: action.result.etag
      });

    case LOAD:
      return (0, _extends4.default)({}, state, {
        loading: true
      });

    case LOAD_SUCCESS:
      return (0, _extends4.default)({}, state, action.result.user, {
        loading: false,
        loaded: true
      });

    case _LOAD_SUCCESS:
      return (0, _extends4.default)({}, state, {
        loading: false,
        loaded: true
      });

    case LOAD_FAIL:
      return (0, _extends4.default)({}, state, {
        loading: false,
        loaded: false,
        loadError: action.error
      });
    case VOUCHER_LOAD:
      return (0, _extends4.default)({}, state, {
        loading_voucher: true,
        loaded_voucher: false
      });

    case VOUCHER_SUCCESS:
      return (0, _extends4.default)({}, state, action.result, {
        loading_voucher: false,
        loaded_voucher: true
      });

    case VOUCHER_FAIL:
      return (0, _extends4.default)({}, state, {
        loading_voucher: false,
        loaded_voucher: false,
        loadError: action.error
      });

    case _auth.LOGOUT_SUCCESS:
    case _auth.LOGIN_SUCCESS:
      return initialState;

    case _assetDownloads.ASSET_ACQUIRE_SUCCESS:
      if (action.result.isError) {
        return state;
      }

      return (0, _extends4.default)({}, state, {
        quota: (0, _extends4.default)({}, state.quota, {
          currentQuota: action.result.currentQuota // state.quota.currentQuota - action.meta.cost
        })
      });

    case _payments.SWITCH_TO_ANNUAL_SUCCESS:
    case _subscriptions.BUY_SUCCESS:
    case _subscriptions.BUY_UPGRADE_SUCCESS:
    case _payments.SUBSCRIBE_TO_UNREAL_UNLIMITED_SUCCESS:
      if (action.result.isError) {
        return state;
      }

      return (0, _extends4.default)({}, state, {
        subscriptionSwitchedFrom: state.subscription,
        subscription: action.result.subscription,
        quota: action.result.quota
      });

    case _topups.BUY_SUCCESS:
      if (action.result.isError) {
        return state;
      }

      return (0, _extends4.default)({}, state, {
        subscriptionSwitchedFrom: null,
        quota: action.result.quota
      });

    case _subscriptions.RESUME_SUBSCRIPTION_SUCCESS:
    case _subscriptions.CANCEL_SUBSCRIPTION_SUCCESS:
      return (0, _extends4.default)({}, state, {
        subscription: action.result.subscription
      });

    case _academicUsers.DOWNLOAD_SUCCESS:
      return _ramda2.default.over(_ramda2.default.lensPath(["academicOffer", "assetPacks"]), _ramda2.default.compose(_ramda2.default.apply(_ramda2.default.adjust(_ramda2.default.evolve({ downloadCount: _ramda2.default.inc }))), _ramda2.default.ap([_ramda2.default.findIndex(_ramda2.default.propEq("id", action.meta.packId)), _ramda2.default.identity]), _ramda2.default.append(_ramda2.default.__, [])), state);

    case MARK_FREE_SEEN:
      var drops = state.drops;
      if (drops) {
        drops.seen = true;
      }

      return (0, _extends4.default)({}, state, {
        drops: drops
      });

    case MARK_FREE_SEEN_SUCCCESS:
      return (0, _extends4.default)({}, state);

    case MARK_FREE_SEEN_FAIL:
      return (0, _extends4.default)({}, state);

    case ACTIVATE_TRIAL:
      return (0, _extends4.default)({}, state, {
        activatingTrial: true,
        activatedTrial: false,
        trialError: ""
      });

    case ACTIVATE_TRIAL_SUCCCESS:
      var trials = {};
      action.result.forEach(function (trial) {
        trials = (0, _extends4.default)({}, trials, (0, _defineProperty3.default)({}, trial.app + "Trial", trial));
      });

      return (0, _extends4.default)({}, state, trials, {
        activatingTrial: false,
        activatedTrial: true,
        trialError: ""
      });

    case ACTIVATE_TRIAL_FAIL:
      return (0, _extends4.default)({}, state, {
        activatingTrial: false,
        activatedTrial: false,
        trialError: "Error activating trial"
      });

    case REDEEM_COUPON:
      return (0, _extends4.default)({}, state, {
        loading: true,
        error: null
      });

    case REDEEM_COUPON_SUCCESS:
      return (0, _extends4.default)({}, state, {
        loading: false,
        loaded: true
      });

    case REDEEM_COUPON_FAIL:
      return (0, _extends4.default)({}, state, {
        loading: false,
        loaded: false,
        error: action.error
      });

    case FETCH_REFUND_ELIGIBILITY:
      return (0, _extends4.default)({}, state, {
        refundEligibility: {
          isLoading: true,
          data: null,
          error: null
        }
      });

    case FETCH_REFUND_ELIGIBILITY_SUCCESS:
      return (0, _extends4.default)({}, state, {
        refundEligibility: {
          isLoading: false,
          data: action.result,
          error: null
        }
      });

    case FETCH_REFUND_ELIGIBILITY_FAILED:
      return (0, _extends4.default)({}, state, {
        refundEligibility: {
          isLoading: false,
          error: action.error,
          data: null
        }
      });

    case FETCH_CASH_REFUND_STATUS:
      return (0, _extends4.default)({}, state, {
        cashRefundStatus: {
          isLoading: true,
          data: {},
          error: null
        }
      });

    case FETCH_CASH_REFUND_STATUS_SUCCESS:
      return (0, _extends4.default)({}, state, {
        cashRefundStatus: {
          isLoading: false,
          data: action.result,
          error: null
        }
      });

    case FETCH_CASH_REFUND_STATUS_FAILED:
      return (0, _extends4.default)({}, state, {
        cashRefundStatus: {
          isLoading: false,
          error: action.error,
          data: {}
        }
      });

    case _auth.ACCEPT_MIXER_EULA_SUCCESS:
      return (0, _extends4.default)({}, state, {
        eulasAccepted: [].concat((0, _toConsumableArray3.default)(state.eulasAccepted), ["mixer_terms"])
      });

    default:
      return state;
  }
}

// Helper functions

function isLoaded(globalState) {
  return globalState.user && globalState.user.loaded;
}

// Action creators
// flag will allow to reload self call even its loaded before.
function load(flag) {
  return function (dispatch, getState) {
    if (getState().auth.loggedIn && (flag || !getState().user.loaded) && !getState().user.loading) {
      return dispatch({
        types: [LOAD, LOAD_SUCCESS, LOAD_FAIL],
        promise: function promise(client) {
          return client.get("v1/users/self").then(function (result) {
            return client.get("sso://v1/users/" + result.email, { includeHeaders: true }).then(function (ssoResult) {
              var etag = ssoResult.headers.etag.replace(/["]+/g, "");

              return {
                user: (0, _extends4.default)({}, _ramda2.default.omit("name", ssoResult.data), result, {
                  etag: etag
                })
              };
            });
          });
        }
      });
    } else {
      return _bluebird2.default.resolve();
    }
  };
}

function markFreeSeen() {
  return {
    types: [MARK_FREE_SEEN, MARK_FREE_SEEN_SUCCCESS, MARK_FREE_SEEN_FAIL],
    promise: function promise(client) {
      return client.post("v1/users/drops/seen");
    }
  };
}
function activateTrial() {
  return {
    types: [ACTIVATE_TRIAL, ACTIVATE_TRIAL_SUCCCESS, ACTIVATE_TRIAL_FAIL],
    promise: function promise(client) {
      return client.post("v1/users/trial", {
        data: {
          app: "global"
        }
      });
    }
  };
}
function setWorkInfo(data) {
  return {
    types: [LOAD, _LOAD_SUCCESS, LOAD_FAIL],
    promise: function promise(client) {
      return client.post("v1/users/self/info", { data: data });
    }
  };
}
function redeemCode(coupon) {
  return {
    types: [REDEEM_COUPON, REDEEM_COUPON_SUCCESS, REDEEM_COUPON_FAIL],
    promise: function promise(client) {
      return client.get("v1/vouchers/" + coupon);
    }
  };
}
function validateVoucherCode(voucher) {
  return {
    types: [VOUCHER_LOAD, VOUCHER_SUCCESS, VOUCHER_FAIL],
    promise: function promise(client) {
      return client.post("v1/vouchers/validate", { data: { voucherId: voucher } });
    }
  };
}
function redeemCodeAction(location) {
  return function (dispatch, getState) {
    var state = getState();
    var loggedIn = state.auth.loggedIn,
        _state$user = state.user,
        subscription = _state$user.subscription,
        loading = _state$user.loading;


    var doesntAlreadyHaveUnrealUnlimited = subscription && subscription.planId !== "unreal-unlimited";

    var coupon = location && location.query && location.query.coupon || null;
    var type = location && location.query && location.query.type || null;

    if (coupon && loggedIn && !type) {
      dispatch(validateVoucherCode(coupon)).then(function (res) {
        if (res.success === true) {
          var userType = "";

          if (subscription && doesntAlreadyHaveUnrealUnlimited) {
            userType = "nt"; // Existing paid user popup
          } else if (!subscription && !loading) {
            userType = "lt"; // New User no subscription popup
          } else if (subscription && !doesntAlreadyHaveUnrealUnlimited) {
            userType = "ut"; //UU User Popup
          }

          if (!subscription) {
            _reactRouter.browserHistory.push({
              pathname: "/",
              search: "?type=" + userType + "&coupon=" + coupon
            });
          } else {
            dispatch(redeemCode(coupon)).then(function (res) {
              if (res.success === true) {
                _reactRouter.browserHistory.push({
                  pathname: "/",
                  search: "?type=" + userType + "&coupon=" + coupon
                });
              }
            });
          }
        }
      }).catch(function (err) {
        // TODO development log only
        var code = err.code;

        if (code === "VOUCHER_INVALID") {
          _reactRouter.browserHistory.push({
            pathname: "/",
            search: "?type=ee&coupon=" + coupon
          });
        } else {
          _reactRouter.browserHistory.push({
            pathname: "/"
          });
        }

        console.log("error logging in", err);

        // handle error
      });
    } else if (coupon && !loggedIn) {
      _reactRouter.browserHistory.replace({
        pathname: "/login",
        search: "?returnTo=/?coupon=" + coupon
      });
    }
  };
}

function acceptEpicWalletTerms() {
  return function (dispatch, getState) {
    var state = getState();
    if (state.auth.loggedIn && !state.user.loading && state.user.loaded) {
      return dispatch({
        types: [GENERIC_ACTION, GENERIC_ACTION_SUCCESS, GENERIC_ACTION_FAILED],
        promise: function promise(client) {
          return client.post("sso://v1/epic_eula/wallet/accept").then(function (result) {
            dispatch((0, _auth.updateTokenAfterAcceptingEula)(result));
            return dispatch(load(true));
          }).then(function () {
            return { success: true, error: null };
          }).catch(function (error) {
            console.error("Error while accepting wallet terms:", error);
            return { success: false, error: error };
          });
        }
      });
    } else {
      return _bluebird2.default.reject("User not authenticated OR is currently loading user data.");
    }
  };
}

function fetchPointsRefundEligibility() {
  return function (dispatch, getState) {
    var state = getState();
    if (state.auth.loggedIn) {
      return dispatch({
        types: [FETCH_REFUND_ELIGIBILITY, FETCH_REFUND_ELIGIBILITY_SUCCESS, FETCH_REFUND_ELIGIBILITY_FAILED],
        promise: function promise(client) {
          return client.get("v1/wallet/refund/eligible");
        }
      });
    } else {
      return _bluebird2.default.reject("A user needs to be logged in to check for refund eligibility.");
    }
  };
}

function creditToEpicWallet() {
  return function (dispatch, getState) {
    var state = getState();
    if (state.auth.loggedIn && !state.user.loading && state.user.loaded) {
      return dispatch({
        types: [GENERIC_ACTION, GENERIC_ACTION_SUCCESS, GENERIC_ACTION_FAILED],
        promise: function promise(client) {
          return client.post("v1/wallet/credit").then(function () {
            return { success: true, error: null };
          }).catch(function (error) {
            console.error("Error while crediting points to Epic Wallet:", error);
            return { success: false, error: error };
          });
        }
      });
    } else {
      return _bluebird2.default.reject("User not authenticated OR is currently loading user data.");
    }
  };
}

function getUserInfoForCashRefund() {
  return function (dispatch, getState) {
    var state = getState();
    if (state.auth.loggedIn && !state.user.loading && state.user.loaded) {
      return dispatch({
        types: [GENERIC_ACTION, GENERIC_ACTION_SUCCESS, GENERIC_ACTION_FAILED],
        promise: function promise(client) {
          return client.get("v1/wallet/user/info").catch(function (error) {
            console.error("Error while fetching user info for cash refund:", error);
            return null;
          });
        }
      });
    } else {
      return _bluebird2.default.reject("User not authenticated OR is currently loading user data.");
    }
  };
}

function registerUserForCashRefund(data) {
  return function (dispatch, getState) {
    var state = getState();
    if (state.auth.loggedIn && !state.user.loading && state.user.loaded) {
      return dispatch({
        types: [GENERIC_ACTION, GENERIC_ACTION_SUCCESS, GENERIC_ACTION_FAILED],
        promise: function promise(client) {
          return client.post("v1/wallet/register/user", { data: data }).then(function (response) {
            return { success: true, error: null };
          }).catch(function (error) {
            console.error("Error while registering user for cash refund:", error);
            return { success: false, error: error };
          });
        }
      });
    } else {
      return _bluebird2.default.reject("User not authenticated OR is currently loading user data.");
    }
  };
}

function retryForCashRefund(data) {
  return function (dispatch, getState) {
    var state = getState();
    if (state.auth.loggedIn && !state.user.loading && state.user.loaded) {
      return dispatch({
        types: [GENERIC_ACTION, GENERIC_ACTION_SUCCESS, GENERIC_ACTION_FAILED],
        promise: function promise(client) {
          return client.post("v1/wallet/retry", { data: data }).then(function (response) {
            return { success: true, error: null };
          }).catch(function (error) {
            console.error("Error while retrying cash refund:", error);
            return { success: false, error: error };
          });
        }
      });
    } else {
      return _bluebird2.default.reject("User not authenticated OR is currently loading user data.");
    }
  };
}

function getStatusForCashRefund() {
  return function (dispatch, getState) {
    var state = getState();
    if (state.auth.loggedIn && !state.user.loading && state.user.loaded) {
      return dispatch({
        types: [FETCH_CASH_REFUND_STATUS, FETCH_CASH_REFUND_STATUS_SUCCESS, FETCH_CASH_REFUND_STATUS_FAILED],
        promise: function promise(client) {
          return client.get("v1/wallet/refund/status");
        }
      });
    } else {
      return _bluebird2.default.reject("User not authenticated OR is currently loading user data.");
    }
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/user.js
// module id = 67
// module chunks = 0